/*
 * Clicks on anything but the navigation links (a) or close button (svg, path, fa-icon) should be nullified
 * return true = event pass-through
 * return void = event intercepted
 */
export function interceptClickEvent($event: MouseEvent): boolean | void {
  return !['a', 'svg', 'path', 'fa-icon'].includes(
    ($event.target as HTMLElement).tagName.toLowerCase(),
  )
    ? $event?.stopPropagation()
    : true;
}
